<!-- =========================================================================================
    Màn hình đăng nhập dc gọi khi trong router kiểm tra là chưa authen
========================================================================================== -->

<template>
  <div></div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router';
import auth from '@/commons/authService';
import { defineComponent, onMounted, reactive, ref, getCurrentInstance } from 'vue';

export default {
  async mounted() {
    const me = this;

    auth.login(me.$route.query?.callback);
  },
};
</script>
